import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CitizenGetAllFeedbackCategories} from './citizen-get-all-feedback-categories.model';
import * as CitizenGetAllFeedbackCategoriesActions from './citizen-get-all-feedback-categories.actions';

export const citizenGetAllFeedbackCategoriesesFeatureKey = 'citizenGetAllFeedbackCategorieses';

export interface State extends EntityState<CitizenGetAllFeedbackCategories> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CitizenGetAllFeedbackCategories> = createEntityAdapter<CitizenGetAllFeedbackCategories>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CitizenGetAllFeedbackCategoriesActions.addCitizenGetAllFeedbackCategories,
    (state, action) => adapter.addOne(action.citizenGetAllFeedbackCategories, state)
  ),
  on(CitizenGetAllFeedbackCategoriesActions.upsertCitizenGetAllFeedbackCategories,
    (state, action) => adapter.upsertOne(action.citizenGetAllFeedbackCategories, state)
  ),
  on(CitizenGetAllFeedbackCategoriesActions.addCitizenGetAllFeedbackCategoriess,
    (state, action) => adapter.addMany(action.citizenGetAllFeedbackCategoriess, state)
  ),
  on(CitizenGetAllFeedbackCategoriesActions.upsertCitizenGetAllFeedbackCategoriess,
    (state, action) => adapter.upsertMany(action.citizenGetAllFeedbackCategoriess, state)
  ),
  on(CitizenGetAllFeedbackCategoriesActions.updateCitizenGetAllFeedbackCategories,
    (state, action) => adapter.updateOne(action.citizenGetAllFeedbackCategories, state)
  ),
  on(CitizenGetAllFeedbackCategoriesActions.updateCitizenGetAllFeedbackCategoriess,
    (state, action) => adapter.updateMany(action.citizenGetAllFeedbackCategoriess, state)
  ),
  on(CitizenGetAllFeedbackCategoriesActions.deleteCitizenGetAllFeedbackCategories,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CitizenGetAllFeedbackCategoriesActions.deleteCitizenGetAllFeedbackCategoriess,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CitizenGetAllFeedbackCategoriesActions.loadCitizenGetAllFeedbackCategoriess,
    (state, action) => adapter.setAll(action.citizenGetAllFeedbackCategoriess, state)
  ),
  on(CitizenGetAllFeedbackCategoriesActions.clearCitizenGetAllFeedbackCategoriess,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
